import React from 'react'
import { useIntl } from 'react-intl'

import { DemoVideo } from '../../components/DemoVideo'
import { SlitePage } from '../../components/SlitePage'
import { useRoutes } from '../../routes'
import { SectionBrowserExtensionButtonsSteps } from './SectionBrowserExtensionButtonsSteps'
import { SectionBrowserExtensionHero } from './SectionBrowserExtensionHero'
import { SectionBrowserExtensionWorkflowSteps } from './SectionBrowserExtensionWorkflowSteps'

const WEB_COMPANION_VIDEO = {
  youtubeId: '4IDae502n1E',
  thumbnailImage:
    'https://cdn.sanity.io/images/dnsgqii5/production/caf624783e5cbc4e9b825646376a664936972221-1990x1121.jpg',
}

export default function BrowserExtensionPage() {
  const intl = useIntl()
  const routes = useRoutes()

  const pageTitle = intl.formatMessage({
    id: 'browserExtension.helmet.title',
    defaultMessage:
      'Slite Browser Extension — Your team assistant on every site',
  })
  const pageDescription = intl.formatMessage({
    id: 'browserExtension.helmet.description',
    defaultMessage:
      'Get context-aware answers and trigger workflows in one click from any website. No copy-pasting, no tab switching.',
  })

  return (
    <SlitePage
      title={pageTitle}
      description={pageDescription}
      canonicalUrl={routes.browserExtension()}
      background="moon-dust-lighter"
    >
      <SectionBrowserExtensionHero />
      <DemoVideo
        youtubeVideoId={WEB_COMPANION_VIDEO.youtubeId}
        videoBackgroundURL={WEB_COMPANION_VIDEO.thumbnailImage}
        background="moon-dust-lighter"
      />
      <SectionBrowserExtensionWorkflowSteps />
      <SectionBrowserExtensionButtonsSteps />
    </SlitePage>
  )
}
